module.exports = __webpack_public_path__ + "media/landing_page/lp4-hero-desktop-03-e5ba05d8.webp";